"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _Presence = _interopRequireDefault(require("composer-lib/data/model/Presence"));

var _PresenceAvatar = _interopRequireDefault(require("composer-lib/components/presence/PresenceAvatar"));

var _constants = require("composer-lib/lib/constants");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _User = _interopRequireDefault(require("composer-lib/data/model/User"));

var COMMENTER_TO_COMMENTER = _constants.PRESENCE_RELATIONSHIPS.COMMENTER_TO_COMMENTER,
    COMMENTER_TO_IDLE_LOCKER = _constants.PRESENCE_RELATIONSHIPS.COMMENTER_TO_IDLE_LOCKER,
    COMMENTER_TO_LOCKER = _constants.PRESENCE_RELATIONSHIPS.COMMENTER_TO_LOCKER,
    LOCKER = _constants.PRESENCE_RELATIONSHIPS.LOCKER,
    REQUESTER_TO_LOCKER = _constants.PRESENCE_RELATIONSHIPS.REQUESTER_TO_LOCKER;

var langKey = function langKey(key) {
  return "composer-lib.header.PresenceAvatars." + key;
};

var _default = (0, _createReactClass.default)({
  displayName: "PresencePopover",
  mixins: [_reactAddonsPureRenderMixin.default],
  propTypes: {
    auth: _propTypes.default.object.isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    dropdownPlacement: _propTypes.default.string,
    open: _propTypes.default.bool,
    passLock: _propTypes.default.func.isRequired,
    prefix: _propTypes.default.string.isRequired,
    presence: _propTypes.default.instanceOf(_Presence.default).isRequired,
    rejectRequestLockFromUser: _propTypes.default.func.isRequired,
    renderChildren: _propTypes.default.func,
    requestLock: _propTypes.default.func.isRequired,
    requestLockFromUser: _propTypes.default.func.isRequired,
    shortUserTitle: _propTypes.default.object.isRequired,
    toggleOpen: _propTypes.default.func.isRequired,
    tooltipPlacement: _propTypes.default.string,
    user: _propTypes.default.instanceOf(_User.default).isRequired
  },
  getDefaultProps: function getDefaultProps() {
    return {
      dropdownPlacement: 'top',
      tooltipPlacement: 'top'
    };
  },
  getOnClickForFooter: function getOnClickForFooter() {
    var prefix = this.props.prefix;

    if (prefix === LOCKER || prefix === REQUESTER_TO_LOCKER) {
      return this.passLock;
    } else if (prefix === COMMENTER_TO_IDLE_LOCKER) {
      return this.acquireLock;
    }

    return this.requestLock;
  },
  getOnClickForFooterCancel: function getOnClickForFooterCancel() {
    var _this$props = this.props,
        prefix = _this$props.prefix,
        toggleOpen = _this$props.toggleOpen;

    if (prefix === REQUESTER_TO_LOCKER) {
      return this.rejectRequestLock;
    }

    return toggleOpen;
  },
  acquireLock: function acquireLock() {
    var _this$props2 = this.props,
        auth = _this$props2.auth,
        composition = _this$props2.composition,
        requestLock = _this$props2.requestLock;
    requestLock(composition.id, auth.session);
  },
  passLock: function passLock() {
    var _this$props3 = this.props,
        auth = _this$props3.auth,
        passLock = _this$props3.passLock,
        composition = _this$props3.composition,
        toggleOpen = _this$props3.toggleOpen,
        user = _this$props3.user;
    toggleOpen();
    passLock(composition.id, auth.session, user.id);
  },
  rejectRequestLock: function rejectRequestLock() {
    var _this$props4 = this.props,
        rejectRequestLockFromUser = _this$props4.rejectRequestLockFromUser,
        toggleOpen = _this$props4.toggleOpen,
        user = _this$props4.user;
    toggleOpen();
    rejectRequestLockFromUser(user.id);
  },
  requestLock: function requestLock() {
    var _this$props5 = this.props,
        auth = _this$props5.auth,
        requestLockFromUser = _this$props5.requestLockFromUser;
    requestLockFromUser(auth.user.get('user_id'));
  },
  renderDropdownFooter: function renderDropdownFooter() {
    var _this$props6 = this.props,
        presence = _this$props6.presence,
        prefix = _this$props6.prefix;
    var disabled = presence.requestedAccess && prefix === COMMENTER_TO_LOCKER;
    var messageKey = disabled ? 'alreadyRequested' : 'footer';
    return _react.default.createElement("div", null, _react.default.createElement(_UIButton.default, {
      disabled: disabled,
      onClick: this.getOnClickForFooter(),
      use: "primary"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: langKey(prefix + "." + messageKey)
    })), _react.default.createElement(_UIButton.default, {
      onClick: this.getOnClickForFooterCancel(),
      use: "secondary"
    }, _react.default.createElement(_FormattedHTMLMessage.default, {
      message: langKey('cancelButton')
    })));
  },
  renderDropdown: function renderDropdown() {
    var _this$props7 = this.props,
        prefix = _this$props7.prefix,
        user = _this$props7.user;
    var firstName = user.firstName,
        lastName = user.lastName;

    if (prefix === COMMENTER_TO_COMMENTER) {
      return null;
    }

    return {
      header: _react.default.createElement("h5", null, _react.default.createElement(_FormattedHTMLMessage.default, {
        message: langKey(prefix + ".title")
      })),
      body: _react.default.createElement(_FormattedHTMLMessage.default, {
        message: langKey(prefix + ".body"),
        options: {
          firstName: firstName,
          lastName: lastName
        }
      }),
      footer: this.renderDropdownFooter()
    };
  },
  renderChild: function renderChild(user, withDropdown) {
    var _this$props8 = this.props,
        open = _this$props8.open,
        prefix = _this$props8.prefix,
        renderChildren = _this$props8.renderChildren,
        shortUserTitle = _this$props8.shortUserTitle,
        toggleOpen = _this$props8.toggleOpen,
        tooltipPlacement = _this$props8.tooltipPlacement;

    if (renderChildren) {
      return renderChildren(user, withDropdown);
    }

    return _react.default.createElement(_PresenceAvatar.default, {
      dropdownOpen: open,
      prefix: prefix,
      shortUserTitle: shortUserTitle,
      toggleOpen: toggleOpen,
      user: user,
      tooltipPlacement: tooltipPlacement,
      withDropdown: withDropdown
    });
  },
  render: function render() {
    var _this$props9 = this.props,
        dropdownPlacement = _this$props9.dropdownPlacement,
        open = _this$props9.open,
        user = _this$props9.user;
    var dropdownContent = this.renderDropdown();

    if (!dropdownContent) {
      return this.renderChild(user, false);
    }

    return _react.default.createElement(_UIPopover.default, {
      content: dropdownContent,
      key: user.id,
      open: open,
      placement: dropdownPlacement,
      width: 325
    }, this.renderChild(user, true));
  }
});

exports.default = _default;
module.exports = exports.default;